<template>
  <section class="hero" id="home">
    <div class="container">
      <div class="hero-content">
        <h1>L'actualité IT & Développement</h1>
        <p>Découvrez les derniers articles, tutoriels et nouvelles technologies en développement web, intelligence artificielle, cybersécurité et bien plus encore.</p>
        <a href="#articles" class="cta-button" @click="scrollToArticles">
          Explorer les articles <i class="fas fa-arrow-right"></i>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroSection', // Changé de Hero à HeroSection
  methods: {
    scrollToArticles(e) {
      e.preventDefault()
      const element = document.getElementById('articles')
      if (element) {
        window.scrollTo({
          top: element.offsetTop - 80,
          behavior: 'smooth'
        })
      }
    }
  }
}
</script>

<style scoped>
.hero {
  padding: 80px 0;
  background: linear-gradient(135deg, var(--primary) 0%, var(--secondary) 100%);
  color: white;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.hero::before {
  content: '';
  position: absolute;
  width: 300px;
  height: 300px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  top: -150px;
  right: -150px;
}

.hero::after {
  content: '';
  position: absolute;
  width: 200px;
  height: 200px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 50%;
  bottom: -100px;
  left: -100px;
}

.hero-content {
  position: relative;
  z-index: 1;
  max-width: 800px;
  margin: 0 auto;
}

.hero h1 {
  font-size: 3.2rem;
  margin-bottom: 20px;
  animation: fadeUp 1s ease;
}

.hero p {
  font-size: 1.2rem;
  margin-bottom: 30px;
  opacity: 0.9;
  animation: fadeUp 1s ease 0.2s both;
}

.cta-button {
  display: inline-block;
  background: white;
  color: var(--primary);
  padding: 14px 32px;
  border-radius: var(--radius);
  text-decoration: none;
  font-weight: 700;
  font-size: 1.1rem;
  transition: var(--transition);
  animation: fadeUp 1s ease 0.4s both;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  border: none;
}

.cta-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 25px rgba(0, 0, 0, 0.25);
}
</style>